import { getSessionId } from '@aspendental/shared-utils/utils';
import Cookies from 'universal-cookie';

import { UserEventsValidationEventValidationsEvent as EVENT_APPOINTMENT_VALUE } from '@src/lib/__generated/user-events-api';
import { useAppStore } from '@src/store';
import restfulClient from '@src/utils/restfulClient';

type Body<T> = {
	[P in keyof T]?: Body<T[P]>;
};

export const userEvent = async (body: Body<EVENT_APPOINTMENT_VALUE>) => {
	const cookies = new Cookies();
	const clientId = cookies.get('_ga')?.substring(6);
	try {
		const response = await restfulClient.post({
			domain: useAppStore.getState().userEventsUrl,
			route: 'user/events',
			data: {
				...body,
				timestamp: new Date().toISOString(),
				event_data: {
					...body.event_data,
					session_id: getSessionId() ?? '',
					...(clientId && { client_id: clientId }),
				},
			},
		});
		return response;
	} catch (e) {
		console.error(e);
	}
};
